<template>
  <router-view></router-view>
</template>


<script>
import Authorizable from "@/mixins/authorizable";
import { mapGetters } from 'vuex';
export default {
  mixins: [Authorizable],
  async beforeCreate() {
      this.$store.watch(
          () => this.$store.getters["profile/me"],
          (me) => {
            window.App = {
              id: me.id,
              user: me.name,
              permissions: me.permissions,
              role: me.roles[0]['name'],
              spinner: me.spinner || 'circle'
            }
            EventBus.$emit('isAutenticated')
            this.title = me.name;
            this.avatar = me.profile_image
                ? me.profile_image
                : "/img/placeholder.jpg";
          }
      );
      await this.$store.dispatch("profile/me");
  },
  metaInfo() {
    return {
      link: [
        { rel: "icon", type: "image/png", href: "/favicon.png" },
        {
          rel: "stylesheet",
          href:
            "https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css",
        },
        {
          rel: "stylesheet",
          href:
            "https://fonts.googleapis.com/css?family=PT+Sans:400,700,200",
        },
        {
          rel: "stylesheet",
          href: "https://use.fontawesome.com/releases/v5.6.3/css/all.css",
          integrity:
            "sha384-UHRtZLI+pbxtHCWp1t77Bi1L4ZtiqrqD80Kn4Z8NTSRyMA2Fd33n5dQ8lWUE00s/",
          crossorigin: "anonymous",
        },
      ],

      // script: (function () {
      //   if (process.env.VUE_APP_IS_DEMO == 1) {
      //     return [
      //       {
      //         hid: "gtm-script1",
      //         innerHTML: `
      //   (function (a, s, y, n, c, h, i, d, e) {
      //   s.className += " " + y;
      //   h.start = 1 * new Date();
      //   h.end = i = function() {
      //     s.className = s.className.replace(RegExp(" ?" + y), "");
      //   };
      //   (a[n] = a[n] || []).hide = h;
      //   setTimeout(function() {
      //     i();
      //     h.end = null;
      //   }, c);
      //   h.timeout = c;
      // })(window, document.documentElement, "async-hide", "dataLayer", 4000, {
      //   "GTM-K9BGS8K": true
      // });
      //   `,
      //         type: "text/javascript",
      //         charset: "utf-8",
      //       },
      //       {
      //         hid: "ga",
      //         innerHTML: `
      //        (function (i, s, o, g, r, a, m) {
      //       i["GoogleAnalyticsObject"] = r;
      //       (i[r] =
      //         i[r] ||
      //         function () {
      //           (i[r].q = i[r].q || []).push(arguments);
      //         }),
      //         (i[r].l = 1 * new Date());
      //       (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
      //       a.async = 1;
      //       a.src = g;
      //       m.parentNode.insertBefore(a, m);
      //     })(
      //       window,
      //       document,
      //       "script",
      //       "https://www.google-analytics.com/analytics.js",
      //       "ga"
      //     );
      //     ga("create", "UA-46172202-22", "auto", { allowLinker: true });
      //     ga("set", "anonymizeIp", true);
      //     ga("require", "GTM-K9BGS8K");
      //     ga("require", "displayfeatures");
      //     ga("require", "linker");
      //     ga("linker:autoLink", ["2checkout.com", "avangate.com"]);
      //         `,
      //         type: "text/javascript",
      //         charset: "utf-8",
      //       },
      //
      //       {
      //         hid: "gtm-script2",
      //         innerHTML: `
      //        (function(w, d, s, l, i) {
      //         w[l] = w[l] || [];
      //         w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
      //         var f = d.getElementsByTagName(s)[0],
      //           j = d.createElement(s),
      //           dl = l != "dataLayer" ? "&l=" + l : "";
      //         j.async = true;
      //         j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
      //         f.parentNode.insertBefore(j, f);
      //       })(window, document, "script", "dataLayer", "GTM-NKDMSK6");
      //         `,
      //         type: "text/javascript",
      //         charset: "utf-8",
      //       },
      //     ];
      //   }
      // })(),
    };
  },
  mounted() {
    const konamiCode = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65];
    let userInput = [];

    window.addEventListener('keydown', (e) => {
      userInput.push(e.keyCode);
      if (userInput.toString().indexOf(konamiCode.toString()) >= 0) {
        document.body.style.fontFamily = 'Mario, sans-serif'; // Change la police ici
        alert('Easter Egg activé ! 🚀');
        userInput = []; // Reset après activation
      }
    });
  }
};
</script>

<style>
@import '../node_modules/@syncfusion/ej2-base/styles/material.css';
@import '../node_modules/@syncfusion/ej2-buttons/styles/material.css';
@import '../node_modules/@syncfusion/ej2-calendars/styles/material.css';
@import '../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
@import '../node_modules/@syncfusion/ej2-inputs/styles/material.css';
@import '../node_modules/@syncfusion/ej2-navigations/styles/material.css';
@import '../node_modules/@syncfusion/ej2-popups/styles/material.css';
@import '../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';
@import "../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
</style>
